import _ from 'lodash';
import moment from 'moment-timezone';

export function diffDeep(obj1:Object | any[], obj2:Object | any[]):boolean {
    try {
        return _.isEqual(obj1, obj2)
    } catch (e) {
        throw e;
    }
}

export function getObjectDiffs(obj1:Record<string, any>, obj2:Record<string, any>) {
    try {
        return Object.keys(obj1).reduce((result, key:string | number) => {
            if (!obj2.hasOwnProperty(key)) {
                // @ts-ignore
                result.push(key);
                // @ts-ignore
            } else if (_.isEqual(obj1[key], obj2[key])) {
                // @ts-ignore
                const resultKeyIndex = result.indexOf(key);
                result.splice(resultKeyIndex, 1);
            }
            return result;
        }, Object.keys(obj2));
    } catch (e) {
        throw (e);
    }
}
/**
 * @param startDate 'ISOstring'
 * @param finishDate 'ISOstring'
 * @returns `'OPEN' or 'SOON' or 'D-*' or '' `
 */
export function calculateDateDiff(startString: string, finishString: string) {
    try {
        const now = new Date()
        const year = now.getFullYear()
        const month = now.getMonth() + 1
        const day = now.getDate()
        const hour = now.getHours()
        const minute = now.getMinutes()
        const second = now.getSeconds()
        let today = moment(`${year}-${month}-${day} ${hour}:${minute}:${second}`, 'YYYY-MM-DD HH:mm:ss')

        if (today.isAfter(finishString)) return 'CLOSED';
        if (today.isBetween(startString, finishString)) return 'OPEN'; // 시작일 또는 종료일이 동일 날짜인 경우 moment 기준으로는 between 이 false. 따라서 아래 코드 사용해야 함
        if (today.isBefore(startString) && Math.abs(today.diff(startString, 'days')) <= 7) return 'SOON';
        if (today.isBefore(startString) && Math.abs(today.diff(startString, 'days')) > 7) return 'D-' + String(moment(startString).diff(today, 'days'));
        return '';
    } catch (e) {
        console.error(e);
        return '';
    }
}
/**
 * @param startDate 'ISOstring'
 * @param finishDate 'ISOstring'
 * @returns `'OPEN' or 'SOON' or 'D-*' or '' `
 */
export function calculateDateDiffV2(startDate: string, finishDate: string) {
    try {
        // if (!startDate) return 'CLOSED'
        const now = new Date()
        const year = now.getFullYear()
        const month = now.getMonth() + 1
        const day = now.getDate()
        const hour = now.getHours()
        const minute = now.getMinutes()
        const second = now.getSeconds()
        let today = moment(`${year}-${month}-${day} ${hour}:${minute}:${second}`, 'YYYY-MM-DD HH:mm:ss')

        if (today.isAfter(finishDate)) return 'CLOSED';
        if (today.isBetween(startDate, finishDate)) return 'OPEN'; // 시작일 또는 종료일이 동일 날짜인 경우 moment 기준으로는 between 이 false. 따라서 아래 코드 사용해야 함
        if (today.isBefore(startDate) && Math.abs(today.diff(startDate, 'days')) <= 7) return 'SOON';
        if (today.isBefore(startDate) && Math.abs(today.diff(startDate, 'days')) > 7) return 'D-' + String(moment(startDate).diff(today, 'days'));
        return '';
    } catch (e) {
        console.error(e);
        return '';
    }
}

const diffs = {
    diffDeep,
    getObjectDiffs,
}

// export {
//     diffDeep,
//     getObjectDiffs,
// }

export default diffs;